// Copyright (c) 2023 by Move Closer

import { ImageData, IRelatedService, ModuleContentResolver, ProductData } from '../../contexts'

import { logger } from '../../support'

import { resolveImage } from '../resolvers'

import { ProductsSetModuleContent, ProductsSetModuleContentInput } from './ProductsSet.contracts'

/**
 * @author Javlon Khalimjonov <javlon.khalimjonov@movecloser.pl>
 */
export const resolveProductsSetModuleContent: ModuleContentResolver<ProductsSetModuleContentInput, ProductsSetModuleContent> =
  async (
    input: ProductsSetModuleContentInput,
    relatedService: IRelatedService
  ): Promise<ProductsSetModuleContent> => {
    const resolvedProducts: { product: ProductData; count: number }[] = []
    let resolvedThumbnail: ImageData | null = null

    const { products, thumbnail } = input

    ;[...products || []].map(async (productEntry) => {
      try {
        const resolvedProduct = await relatedService.resolve<ProductData>(productEntry.product)
        resolvedProducts.push({
          product: resolvedProduct,
          count: productEntry.count ?? 1
        })
      } catch (e) {
        logger(e, 'warn')
      }
    })

    if (thumbnail) {
      try {
        resolvedThumbnail = await resolveImage(thumbnail, relatedService)
      } catch (e) {
        logger(e, 'warn')
      }
    }

    return {
      ...input,
      products: resolvedProducts,
      thumbnail: resolvedThumbnail
    }
  }
